export const addInvoiceMixin = {
  methods: {
    getBuyerFromId(id) {
      return this.exporterData.clients_locked.find((element) => {
        return id === element.importer_user_id
      })
    },
    navigate(component, id, value) {
      this.$router
        .push({
          name: component,
          params: {
            id: id || '',
            value: value || ''
          }
        })
        .catch(() => {})
    },
    setDates() {
      Object.keys(this.dates).forEach((key) => {
        this.form[key] = this.$formatDate(
          this.$convertStringToDatePattern(
            this.dates[key],
            this.options.format
          ),
          'DD-MM-YYYY'
        )
      })
    },
    getDates(data) {
      Object.keys(this.dates).forEach((key) => {
        if (data[key]) {
          this.dates[key] = this.$formatDate(
            this.$convertStringToDatePattern(data[key]),
            'DD/MM/YYYY'
          )
        }
      })
    }
  },
  directives: {
    tabindex: {
      inserted(el) {
        el.setAttribute('tabindex', 0)
      }
    }
  }
}
